var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "brand-review-result" }, [
    _vm.isApproved === null
      ? _c("div", { staticClass: "brand-review-result-inreview" }, [
          _c("div", { staticClass: "brand-review-result-title" }, [
            _vm._v("Thanks!")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "brand-review-result-content" }, [
            _vm._v("Thanks!")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "brand-review-result-content" }, [
            _vm._v(
              "Your responses will be reviewed by someone on the ShopVidi team"
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "brand-review-result-content" }, [
            _vm._v(
              "The review is expected to be completed within 48 hours (working days,extended on holidays)."
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "brand-review-result-content" }, [
            _vm._v("Our sales team will get in touch with you.")
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "brand-review-action",
              attrs: { target: "_blank", href: "https://www.shopvidi.com" }
            },
            [_vm._v("Go to ShopVidi")]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isApproved === false
      ? _c("div", { staticClass: "brand-review-result-declined" }, [
          _c("div", { staticClass: "brand-review-result-title" }, [
            _vm._v("Sorry!")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "brand-review-result-content" }, [
            _vm._v(
              "Thank you for submitting your registration application on our platform. After careful review, we regret to inform you that your registration has not been approved. If you wish to explore further collaboration opportunities, please feel free to contact the ShopVidi team."
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-521ddf17", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-521ddf17","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/brand-review/brand-review-result.vue
// module id = kS6m
// module chunks = 2